import { useQuery } from "@tanstack/react-query"

import {
    SurveyResult,
    SurveyList,
    SurveyQuestions,
    FetchQuestionnaireProfilesResponse,
} from "modules/NewClientSurvey/common"
import { prepareSurveyQuestions } from "modules/NewClientSurvey/common/utils/prepareDataApi"
import { httpClient } from "utils/infrastructure/httpClient"

const SURVEY_LIST = "SURVEY_LIST"
const SURVEY_BY_SLUG = "SURVEY_BY_SLUG"

export function getSurveyList() {
    return httpClient.get<SurveyList[]>("survey/list")
}

export function getSurveyBySlug(slug: string) {
    return httpClient.get<SurveyQuestions>(`${slug.replace("/api/", "")}`)
}

export function saveSurveyV2(data: SurveyResult) {
    return httpClient.post<FetchQuestionnaireProfilesResponse>("survey/v2/result/add", data)
}

export function useGetSurveyList() {
    return useQuery<SurveyList[]>([SURVEY_LIST], getSurveyList, {
        refetchOnWindowFocus: false,
    })
}

export function useGetSurveyBySlug(slug: string) {
    return useQuery([SURVEY_BY_SLUG, slug], () => getSurveyBySlug(slug), {
        enabled: !!slug,
        refetchOnWindowFocus: false,
        select: prepareSurveyQuestions,
        onError: (err) => console.log("Не смог получить анкету: ", err),
    })
}
